import React from "react";
import { Typography } from "antd";
import styles from "./students.module.css";
import StatisticsOverview from "./components/statistics-overview/statistics-overview";
import StudentViewTabs from "./components/student-view-tabs/student-view-tabs";
import { useAcademicYears } from "../../hooks/useAcademicYear";

const Students = () => {
  const { selectedYearName } = useAcademicYears();
  return (
    <div className={styles.students}>
      <Typography className={styles.title}>Overview</Typography>
      <p className={styles.yearText}>
        Academic Year: {selectedYearName}
      </p>
      <StatisticsOverview />
      <StudentViewTabs />
    </div>
  );
};

export default Students;
